module.exports = "/_next/static/images/Claim-proseries-91ac081056bf38b176d1f85056620a55.png";